import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext({
  user: null,
  login: async () => {},
  logout: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  // Demo mode - check localStorage on mount
  useEffect(() => {
    const savedUser = localStorage.getItem("demo_user");
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem("demo_user");
      }
    }
  }, []);

  const login = async (passkey) => {
    // Demo mode - accept any passkey
    if (passkey === "admin123" || passkey) {
      const demoUser = {
        id: "demo-admin",
        email: "admin@demo.app",
        name: "Admin",
        role: "admin",
      };
      localStorage.setItem("demo_user", JSON.stringify(demoUser));
      setUser(demoUser);
      return { ok: true };
    }
    return { ok: false, error: "Invalid passkey" };
  };

  const logout = async () => {
    localStorage.removeItem("demo_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}